import { render, staticRenderFns } from "./PurchaseOrderDetail.vue?vue&type=template&id=105f4606&scoped=true"
import script from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderDetail.vue?vue&type=style&index=0&id=105f4606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105f4606",
  null
  
)

export default component.exports